/* tslint:disable */
/* eslint-disable */
/**
 * AIS Database Loader API
 * API for retrieving AIS database and filestore date ranges.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DailyRangeGet200ResponseDatabase } from './DailyRangeGet200ResponseDatabase';
import {
    DailyRangeGet200ResponseDatabaseFromJSON,
    DailyRangeGet200ResponseDatabaseFromJSONTyped,
    DailyRangeGet200ResponseDatabaseToJSON,
} from './DailyRangeGet200ResponseDatabase';
import type { DailyRangeGet200ResponseFilestore } from './DailyRangeGet200ResponseFilestore';
import {
    DailyRangeGet200ResponseFilestoreFromJSON,
    DailyRangeGet200ResponseFilestoreFromJSONTyped,
    DailyRangeGet200ResponseFilestoreToJSON,
} from './DailyRangeGet200ResponseFilestore';

/**
 * 
 * @export
 * @interface DailyRangeGet200Response
 */
export interface DailyRangeGet200Response {
    /**
     * 
     * @type {DailyRangeGet200ResponseDatabase}
     * @memberof DailyRangeGet200Response
     */
    database: DailyRangeGet200ResponseDatabase;
    /**
     * 
     * @type {DailyRangeGet200ResponseFilestore}
     * @memberof DailyRangeGet200Response
     */
    filestore: DailyRangeGet200ResponseFilestore;
}

/**
 * Check if a given object implements the DailyRangeGet200Response interface.
 */
export function instanceOfDailyRangeGet200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "database" in value;
    isInstance = isInstance && "filestore" in value;

    return isInstance;
}

export function DailyRangeGet200ResponseFromJSON(json: any): DailyRangeGet200Response {
    return DailyRangeGet200ResponseFromJSONTyped(json, false);
}

export function DailyRangeGet200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DailyRangeGet200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'database': DailyRangeGet200ResponseDatabaseFromJSON(json['database']),
        'filestore': DailyRangeGet200ResponseFilestoreFromJSON(json['filestore']),
    };
}

export function DailyRangeGet200ResponseToJSON(value?: DailyRangeGet200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'database': DailyRangeGet200ResponseDatabaseToJSON(value.database),
        'filestore': DailyRangeGet200ResponseFilestoreToJSON(value.filestore),
    };
}

